/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AccountGeneratorRequest} from '@cash-web/protos/squareup/cash/cashtestingtools/api/v1beta1/account_generator_proto.pb'
import {AccountGeneratorResponse} from '@cash-web/protos/squareup/cash/cashtestingtools/api/v1beta1/account_generator_proto.pb'


export const accountGenerator = (request: AccountGeneratorRequest, options?: CashRequestOptions) => post<AccountGeneratorRequest, AccountGeneratorResponse>("/generate-account", request, {...options, rejectOnError: true })